import React, { Component } from 'react';
import { connect } from 'shalala';
import { Col, Row } from 'react-bootstrap';

import { useStore } from '../../store';
import PrefacturaList from './list/PrefacturaList';
import PrefacturasSearch from './list/components/PrefacturasSearch';

class Prefacturas extends Component {

  state = {
    selectable: false,
    selectedRowKeys: [],
    selectedRows: []
  }

  componentDidMount() {
    window.setAppTitle('Prefacturas');
  }

  handleOnRowSelectionChange = ({selectedRowKeys, selectedRows}) => {
    this.setState({
      selectedRowKeys,
      selectedRows
    });
  }

  handleOnRowClick = (data) => {
    this.props.history.push({
      pathname: `/app/prefacturas/${data.id}/info`,
      state: {
        data: {
          ...data
        }
      }
    });
  }

  handleOnToggleSelectableTableItems = () => {
    this.setState({
      selectable: !this.state.selectable
    });
  }

  handleOnFilterChange = (filters) => {
    this.props.paginate({
      page: 1,
      ...filters
    })
  }

  render() {
    const { selectable } = this.state;

    return (
      <>
        <Row className="mb-1">
          <Col sm="12" md="9">
            <PrefacturasSearch />
          </Col>
        </Row>

        <PrefacturaList
          selectable={ selectable }
          onRowClick={ this.handleOnRowClick }
          onRowSelectionChange={ this.handleOnRowSelectionChange }
        />
      </>
    )
  }
}

const mapState = (state) => {
  return state.app.prefacturas.list
}

const mapActions = (actions) => {
  return {
    paginate: actions.app.prefacturas.list.paginate,
  };
}

export default connect(useStore, mapState, mapActions)(Prefacturas);